<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div class="mb-4 custom-grid-wrapper">
          <span>Data consolidata</span>
          <strong>{{ consolidatedAt }}</strong>
        </div>
        <div class="errors-wrapper">
          <div v-if="loadError" class="error-item">
            <p><i>Impossibile caricare i movimenti non mappati.</i></p>
          </div>
          <div v-else-if="!entries.length" class="error-item">
            <p><i>Nessun movimento non mappato.</i></p>
          </div>
          <div
            v-for="entry in entries"
            :key="entry.book_entry_id"
            class="error-item"
          >
            <div class="custom-grid-wrapper">
              <span>Registrazione</span>
              <strong>{{ entry.book_entry_title }}</strong>
              <span>Cosa manca</span>
              <ul class="mb-0 pl-3">
                <li v-for="reason in entry.reasons" :key="reason">
                  <strong>{{ reason }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center mt-5">
          <base-icon name="loading" width="35" height="35" />
          <p id="cancel-label">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import moment from "moment";
moment.locale("it");

export default {
  name: "Unmapped",
  components: {
    BaseIcon,
  },
  data() {
    return {
      entries: [],
      loadError: false,
      isLoading: true,
      repository: "fattutto",
    };
  },
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    onSearch() {
      const Repo = RepositoryFactory.get(this.repository);
      const id = this?.dbRowData?.fattutto_transmission?.id;
      if (!id) {
        this.loadError = true;
        this.isLoading = false;
        this.$showSnackbar({
          preset: "error",
          text: `Siamo spiacenti, c'è stato un errore. Ti preghiamo di riprovare più tardi.`,
        });
        return;
      }
      Repo.unmapped_transmission(id)
        .then((response) => {
          this.entries = response?.data?.data ?? [];
        })
        .catch((error) => {
          this.loadError = true;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    consolidatedAt() {
      return this?.dbRowData?.consolidated_at
        ? moment(this.dbRowData.consolidated_at).format("DD/MM/YYYY")
        : "-";
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>
